import React from 'react'
import NumericalValue from './NumericalValue'

import { priceFormatter } from '../logic/financials/precise'

interface Props {
  value: number
  precision?: number
  numericFontSize?: string
  nonNumericFontSize?: string
}
function PercentageValue({ value, numericFontSize, nonNumericFontSize }: Props) {
  const v = value * 100
  const val = priceFormatter(v, 3)
  return <div style={{display:'flex'}}>
    <NumericalValue fontSize={numericFontSize}>{val}</NumericalValue><NumericalValue fontSize={nonNumericFontSize}>{'%'}</NumericalValue>
  </div>
}

export default PercentageValue
